import { createDecagonClient } from '@user-portal/chatbot';

import { SOURCE } from 'constants/general';

export const decagonClient = createDecagonClient({
    projectId: 'yoga',
    source: SOURCE,
    env: import.meta.env.ENV === 'prod' ? 'prod' : 'stage',
});
